export interface CheckoutFormState {
  businessJustification: string;
  costCenter: string;
  carCode: string;
  serialNumberForReturnDevice: string;
  managerConfirmationCheckbox: boolean;
  shippingDetailsConfirmationCheckbox: boolean;
  policyConfirmationCheckbox: boolean;
  deliveryInstructions: string;
  fullName: string;
  country: string;
  countryISO3: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  citySubdivision1: string;
  county: string;
  postalCode: string;
  countryCode: string;
  phoneNumber: string;
}

export const checkoutFormDefaultValues: CheckoutFormState = {
  businessJustification: "",
  costCenter: "",
  carCode: "",
  serialNumberForReturnDevice: "",
  managerConfirmationCheckbox: false,
  shippingDetailsConfirmationCheckbox: false,
  policyConfirmationCheckbox: false,
  deliveryInstructions: "",
  fullName: "",
  country: "",
  countryISO3: "",
  addressLine1: "",
  addressLine2: "",
  addressLine3: "",
  city: "",
  citySubdivision1: "",
  county: "",
  postalCode: "",
  countryCode: "",
  phoneNumber: "",
};
